<template>
  <b-table
    :fields="fieldsMaterial"
    :items="GET_MATERIAL_REMAINS.results"
    show-empty
    responsive
    hover
    :empty-text="$t('empty_text')"
    @row-clicked="$emit('row-selected', $event)"
  >
    <template #head()="props">
      <span>{{ $t(props.label) }}</span>
    </template>
    <template #cell(category)="{ item }">
      <span v-if="item.product.category && item.product.category.title">
        {{ item.product.category.title }}
      </span>
    </template>
    <template #cell(character)="{ item }">
      {{ item.product.character }}
    </template>
    <template #cell(value)="{ item }">
      {{ item.value }}
    </template>
    <template #cell(unity)="{ item }">
      {{ item.unity }}
    </template>
    <template #cell(total_count)="{ item }">
      {{ $_formatPriceMixin(item.total_count) }}
    </template>


    <template #cell(actions)>
      <div class="d-flex align-items-center">
        <b-button variant="primary" size="sm">
          <feather-icon icon="CheckIcon" size="16" />
        </b-button>

        <b-button
          v-b-modal.modal-material-warehouse
          variant="outline-success"
          class="ml-50 mt-50 mb-50"
          size="sm"
        >
          Поделиться
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import { BButton, BTable } from "bootstrap-vue";
import { mapGetters } from "vuex";
import priceFormatMixin from '@/mixins/priceFormatMixin.js'

export default {
  components: {
    BTable,
    BButton,
  },
  mixins: [priceFormatMixin],
  data: () => ({
    fieldsMaterial: [
      {
        label: "№",
        key: "id",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "reference.categoriya",
        key: "category",
        formatter: (value) => value && value.category,
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "courses.type",
        key: "product",
        formatter: (value) => value.title,
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "reference.name",
        key: "value",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "reference.units",
        key: "unity",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "amount",
        key: "total_count",
        thClass: "text-center",
        tdClass: "text-center",
      },
    ],
  }),
  computed: {
    ...mapGetters("materials", ["GET_MATERIAL_REMAINS"]),
  },
};
</script>

<style lang='scss'>

</style>
